const routes = [
	{
		path: '/statistics-reports/course-man-days',
		name: 'CourseManDays',
		component: () => import('./course-man-days/index.vue'),
		// meta: {
		//         roles: ['Reports'],
		//         permissions: ['list_roles']
		//       }
	},
	{
		path: '/statistics-reports/training-services',
		name: 'TrainingServices',
		component: () => import('./training-services/index.vue'),
		// meta: {
		//         roles: ['Reports'],
		//         permissions: ['list_roles']
		//       }
	},

	{
		path: '/statistics-reports/course-delivery',
		name: 'CourseDelivery',
		component: () => import('./course-delivery/CourseDeliveryView.vue'),
	},
	{
		path: '/statistics-reports/top-courses',
		name: 'TopCourses',
		component: () => import('./top-courses/TopCoursesView.vue'),
	},
	{
		path: '/statistics-reports/resource-utilization',
		name: 'ResourceUtilization',
		component: () =>
			import('./resource-utilization/ResourceUtilizationView.vue'),
		meta: {
			requiresAuth: true,
			title: 'Resource Utilization Report',
		},
	},
];

export default routes;
